/**
 * @desc ebs
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.warehouseCost.ebs.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouseCost/ebs`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
